import { belongsTo, hasMany } from 'miragejs';
import ScreeningCardable from './screening-cardable';
import attr from 'ember-data/attr';

export default ScreeningCardable.extend({
  approvalStatus: belongsTo('graphql/approval-status'),
  entry: belongsTo('graphql/entry'),
  location: belongsTo('graphql/location'),
  userData: hasMany('graphql/user-data'),
  visitor: belongsTo('graphql/visitor'),

  expectedArrivalTime: attr('date'),
});
